import { ApiConfig } from "../apiConfig/apiConfig";
import { ApiCallGet, ApiCallPost } from "../apiConfig/apiCall";
import { deviceAuthHeaders } from "../../utils/deviceId";

/** `Authorization: Bearer <access_token>` + `X-Device-Id`, same as other wallet calls. */
function authHeaders() {
  let raw = null;
  try {
    raw = localStorage.getItem("token") || sessionStorage.getItem("token");
  } catch {
    raw = null;
  }
  const headers = deviceAuthHeaders();
  if (!raw) return headers;
  const token = String(raw).startsWith("Bearer ") ? raw : `Bearer ${raw}`;
  return { ...headers, Authorization: token };
}

/** `GET /v1/wallet/deposits?limit=50` */
export function listWalletDeposits() {
  const { baseWallet, walletDeposits } = ApiConfig;
  return ApiCallGet(`${baseWallet}${walletDeposits}?limit=50`, authHeaders());
}

/** `GET /v1/wallet/deposit-declarations` */
export function listPendingDepositDeclarations() {
  const { baseWallet, depositDeclarations } = ApiConfig;
  return ApiCallGet(`${baseWallet}${depositDeclarations}`, authHeaders());
}

/** `GET /v1/wallet/deposit-declarations/:depositId` */
export function getDepositDeclaration(depositId) {
  const { baseWallet, depositDeclarations } = ApiConfig;
  const id = encodeURIComponent(String(depositId || "").trim());
  return ApiCallGet(`${baseWallet}${depositDeclarations}/${id}`, authHeaders());
}

/** `POST /v1/wallet/deposit-declarations/:depositId` */
export function submitDepositDeclaration(depositId, body) {
  const { baseWallet, depositDeclarations } = ApiConfig;
  const id = encodeURIComponent(String(depositId || "").trim());
  return ApiCallPost(`${baseWallet}${depositDeclarations}/${id}`, body, authHeaders());
}

/** `GET /api/v1/wallet/withdrawal-declarations` */
export function listPendingWithdrawalDeclarations() {
  const { baseWalletV1Api, withdrawalDeclarations } = ApiConfig;
  return ApiCallGet(`${baseWalletV1Api}${withdrawalDeclarations}`, authHeaders());
}

/** `GET /api/v1/wallet/withdrawal-declarations/:withdrawalId` */
export function getWithdrawalDeclaration(withdrawalId) {
  const { baseWalletV1Api, withdrawalDeclarations } = ApiConfig;
  const id = encodeURIComponent(String(withdrawalId || "").trim());
  return ApiCallGet(`${baseWalletV1Api}${withdrawalDeclarations}/${id}`, authHeaders());
}

/** `POST /api/v1/wallet/withdrawal-declarations/:withdrawalId` */
export function submitWithdrawalDeclaration(withdrawalId, body) {
  const { baseWalletV1Api, withdrawalDeclarations } = ApiConfig;
  const id = encodeURIComponent(String(withdrawalId || "").trim());
  return ApiCallPost(`${baseWalletV1Api}${withdrawalDeclarations}/${id}`, body, authHeaders());
}

/** `GET /v1/wallet/user-wallet` — server credits the main wallet; the client only refreshes it. */
export function refreshUserWallet() {
  const { baseWallet, userfunds } = ApiConfig;
  return ApiCallGet(`${baseWallet}${userfunds}`, authHeaders());
}
